/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import MSDyBaseCartesian from './msdybasecartesian';
import canvas3dFactory from '../_internal/factories/canvas-3d-axis-ref-cartesian';

/**
 * Creates class for MSDybaseCartesian3D
 */
class MSDybaseCartesian3D extends MSDyBaseCartesian {
  /**
   * constructor fn
   */
  constructor () {
    super();
    this.registerFactory('canvas', canvas3dFactory);
  }
  /**
   * Parse the chart attributes and store in chart's config
   * @param {Object} dataObj User input json
   */
  parseChartAttr (dataObj) {
    super.parseChartAttr(dataObj);
    this.config.drawTrendRegion = 0;
  }
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'MSDybaseCartesian3D';
  }
  /**
   * Sets default configuration
   * @memberof MSDybaseCartesian3D
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    this.config.is3D = true;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'MSDybaseCartesian3D';
  }
}
export default MSDybaseCartesian3D;
